export interface FAQItem {
  question: string;
  answer: string;
}

export const faqItems: FAQItem[] = [
  {
    question: '「淫」字的本义是什么？',
    answer: '「淫」字的本义是"久雨"，即连绵不断的雨。《说文解字》："淫，侵淫随理也。从水㸒声。一曰久雨为淫。"《尔雅·释天》："久雨谓之淫。"《礼记·月令》郑玄注："淫，霖也，雨三日以上为霖。"从本义"久雨"引申出"过度、过分"的抽象意义，再进一步引申为"放纵、沉溺"。',
  },
  {
    question: '「淫」和「霪」「婬」有什么区别？',
    answer: '这三个字同源，均以「㸒」为声符，但义符不同导致语义侧重不同：「淫」从水，本义久雨，后泛指过度、放纵；「霪」从雨，专门表示久雨这一气象意义；「婬」从女，专指性道德方面的邪僻放荡。在现代规范中，「淫」为正体且使用最广，「霪」保留在特定的"久雨"义项上，「婬」在大多数语境中已被「淫」取代。',
  },
  {
    question: '孔子说的"乐而不淫"是什么意思？',
    answer: '"乐而不淫，哀而不伤"出自《论语·八佾》，是孔子对《诗经·关雎》的评价。意思是有欢乐但不放纵过度，有哀愁但不至于伤痛。这里的「淫」是"过度、放纵"之意，不是后世的"淫秽"之义。朱熹注："淫者，乐之过而失其正者也。"这一命题奠定了中国古典美学"中和之美"的基本原则，强调情感表达的适度与节制。',
  },
  {
    question: '「淫」字在现代汉语中的用法发生了什么变化？',
    answer: '现代汉语中「淫」字经历了显著的语义收缩。古代丰富的义项——久雨、过度、放纵、沉溺——在日常用语中大多退居幕后，取而代之的主要是与性道德相关的负面含义（如"淫秽""淫乱"）。"淫雨""淫乐""浸淫"等传统用法在现代文本中使用频率显著降低，多限于书面语或特定文体。不过在学术研究（尤其是古汉语研究）中，「淫」字的丰富语义网络仍得到完整保留。',
  },
  {
    question: '如何正确理解中国古代文献中的「淫」字？',
    answer: '理解古代文献中的「淫」字，需要注意以下几点：首先，根据具体语境判断其含义，"淫雨"中的「淫」是"久"的意思，"淫乐"中的「淫」是"过度"的意思；其次，不要将现代汉语中"淫秽"的强烈负面色彩强加于古代文献，古文中「淫」在许多语境中仅仅是"过度"的中性描述；最后，要注意「淫」在儒家经典中作为核心伦理概念的特殊用法，它往往代表了对"礼"的偏离和对"中道"的违背。',
  },
  {
    question: '「淫」字的字形是如何演变的？',
    answer: '「淫」字在甲骨文时期尚未独立出现，但其声符「㸒」已见于商代卜辞。西周金文中「淫」开始以"从水㸒声"的形声字面貌出现。战国时期出现多种异体写法。秦统一文字后，小篆「淫」字形体趋于规范。经过隶变、楷化的演变，最终形成今天通行的「淫」字。在其演变过程中，还分化出了「霪」「婬」等异体字。',
  },
];